import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import "./AdminLayout.css";

const NAV_ITEMS = [
  { label: "Dashboard",    to: "/admin/dashboard",    icon: "fa-solid fa-gauge-high" },
  { label: "Projects",     to: "/admin/projects",     icon: "fa-solid fa-briefcase" },
  { label: "Services",     to: "/admin/services",     icon: "fa-solid fa-layer-group" },
  { label: "Team",         to: "/admin/team",         icon: "fa-solid fa-users" },
  { label: "Testimonials", to: "/admin/testimonials", icon: "fa-solid fa-star" },
  { label: "Tech Stack",   to: "/admin/tech",         icon: "fa-solid fa-microchip" },
  { label: "Pricing",      to: "/admin/pricing",      icon: "fa-solid fa-tag" },
  { label: "Messages",     to: "/admin/messages",     icon: "fa-solid fa-envelope" },
  { label: "Hero/Content", to: "/admin/content",      icon: "fa-solid fa-pen-to-square" },
  { label: "Users",        to: "/admin/users",        icon: "fa-solid fa-user-shield" },
  { label: "Settings",     to: "/admin/settings",     icon: "fa-solid fa-gear" },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate          = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className={`adm-shell ${collapsed ? "adm-shell--collapsed" : ""} ${mobileOpen ? "adm-shell--mobile-open" : ""}`}>

      {/* ── Mobile overlay ── */}
      {mobileOpen && (
        <div className="adm-overlay" onClick={() => setMobileOpen(false)} />
      )}

      {/* ── Sidebar ── */}
      <aside className="adm-sidebar">

        {/* Logo */}
        <div className="adm-sidebar-logo">
        <img src={`${process.env.PUBLIC_URL}/SolviotechFavicon.ico`} alt="Solviotech" style={{ height: "32px", width: "32px", objectFit: "contain", borderRadius: "6px" }} />
          {!collapsed && <span className="adm-logo-text">Solvio<span className="adm-logo-accent">tech</span></span>}
          <button
            className="adm-collapse-btn desktop-only"
            onClick={() => setCollapsed((v) => !v)}
            aria-label="Toggle sidebar"
          >
            <i className={`fa-solid fa-chevron-${collapsed ? "right" : "left"}`}></i>
          </button>
        </div>

        {/* Nav */}
        <nav className="adm-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `adm-nav-item ${isActive ? "adm-nav-item--active" : ""}`
              }
              onClick={() => setMobileOpen(false)}
              title={collapsed ? item.label : undefined}
            >
              <i className={item.icon}></i>
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        {/* User footer */}
        <div className="adm-sidebar-footer">
          <div className="adm-user-info">
            <div className="adm-user-avatar">
              {user?.username?.[0]?.toUpperCase() || "A"}
            </div>
            {!collapsed && (
              <div className="adm-user-details">
                <span className="adm-user-name">{user?.username || "Admin"}</span>
                <span className="adm-user-role">{user?.role || "admin"}</span>
              </div>
            )}
          </div>
          <button
            className="adm-logout-btn"
            onClick={handleLogout}
            title="Log out"
          >
            <i className="fa-solid fa-right-from-bracket"></i>
          </button>
        </div>
      </aside>

      {/* ── Main content area ── */}
      <div className="adm-main">

        {/* Top bar */}
        <header className="adm-topbar">
          <button
            className="adm-mobile-menu-btn mobile-only"
            onClick={() => setMobileOpen((v) => !v)}
          >
            <i className="fa-solid fa-bars"></i>
          </button>

          <div className="adm-topbar-title">
            Admin Panel
          </div>

          <div className="adm-topbar-actions">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="adm-view-site-btn"
            >
              <i className="fa-solid fa-arrow-up-right-from-square"></i>
              View Site
            </a>
          </div>
        </header>

        {/* Page content — rendered by child routes */}
        <main className="adm-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
